export class FileTransformer {
  static transform(obj) {

    let file = {}
    file.id = obj.id
    file.uploadableType = obj.attributes.uploadable_type
    file.uploadableId = obj.attributes.uploadable_id
    file.filename = obj.attributes.filename
    file.mime = obj.attributes.mime
    file.path = obj.attributes.path
    file.status = obj.attributes.status
    file.subtype = obj.attributes.subtype
    file.description = obj.attributes.description ? obj.attributes.description : ''
    file.thumbnail = obj.attributes.thumbnail ? obj.attributes.thumbnail : null
    file.name = obj.attributes.name
    file.tags = obj.relationships.tags.data
    file.createdAt = obj.attributes.created_at

    return file
  }


  static name(uploadable_type) {

    switch(uploadable_type) {

        case 'Stormport\\Firms\\Firm': return 'Firm'; break;

        case 'Stormport\\Orders\\Order': return 'Order'; break;

        default: return 'Form'; break;

    }

  }


}



// WEBPACK FOOTER //
// ./src/helpers/files/file.transformer.js